<n-slide-window *ngIf="pageReady" [visible]="windowVisible" [width]="isSimpleMode ? '6.08rem' : '8rem'" [showMask]="false" [outClickHide]="true"
    (onHide)="close()">
    <n-header>
        <h1 nTextTips>{{data.SHAREPATH}}</h1>
        <n-help-link key="nfsView" *ngIf = '!SWITCH.IS_SIMPLE_MODE'></n-help-link>
        <n-help-link key="simplifynfsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-split-button
            class="ml-auto"
            id="nfs_detail_action_btn"
            [simpleMode]="SWITCH.IS_SIMPLE_MODE"
            [label]="i18n.btn.actionBtn"
            [items]="operationBtns">
        </n-split-button>
    </n-header>
    <n-block [title]="i18n.title.basicInfo">
        <n-lv id="detail-nfs-share-lv" [colcount]="2" [simpleMode]="SWITCH.IS_SIMPLE_MODE">
            <!-- 共享名称 -->
            <n-lv-item [label]="i18n.label.share_name">
                <span class="text-wrap">{{data.NAME}}</span>
            </n-lv-item>
            <!-- 共享路径 -->
            <n-lv-item [label]="i18n.label.share_path">
                <span class="text-wrap">{{data.SHAREPATH}}</span>
            </n-lv-item>
            <!-- 所属租户 -->
            <n-lv-item [label]="i18n.label.vStoreLab" *ngIf="!isSimpleMode">
                <span>{{data.vstoreName || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- notify -->
            <n-lv-item [label]="i18n.label.charEncoding">
                <span class="text-wrap">{{charEncodingType[data.CHARACTERENCODING]}}</span>
            </n-lv-item>
            <!-- 显示Snapshot -->
            <n-lv-item [label]="i18n.label.showSnapShotLab" *ngIf="!ProductConfig.isHideNfsSnapShot">
                <span class="text-wrap">{{utilService.getLabelFromOptions | fn :enableShowSnapOpts :data.ENABLESHOWSNAPSHOT}}</span>
            </n-lv-item>
            <!-- 描述 -->
            <n-lv-item [label]="i18n.label.description" [colspan]="2">
                <span class="text-wrap">{{utilService.decodeHTML | fn :data.DESCRIPTION || UNPLACEHOLDER}}</span>
            </n-lv-item>
        </n-lv>
    </n-block>

    <!-- 极简模式只显示"权限" -->
    <n-block [title]="i18n.title.permissionList" *ngIf="data.FSID !== UNPLACEHOLDER && isSimpleMode">
        <ng-container [ngTemplateOutlet]="addClients"></ng-container>
    </n-block>

    <!-- 标准模式显示tab -->
    <n-tab *ngIf="data.FSID !== UNPLACEHOLDER && !isSimpleMode"
        class="mt-20"
        [(activeItem)]="activeTab">
        <!-- 权限tab -->
        <n-tab-item [header]="i18n.title.permissionList">
            <ng-container [ngTemplateOutlet]="addClients"></ng-container>
        </n-tab-item>
        <n-tab-item [header]="i18n.title.extensionFiltering" *ngIf="!ProductConfig.isHideNfsFileFiltering">
            <!-- 文件扩展名过滤tab -->
            <ng-template nTemplate>
                <div class="nfs-detail-tab">
                    <app-extension-filtering #extensionFilteringDt
                        class="feature-container"
                        [share]="data"
                        [shareType]="ShareMoTypeE.NFS">
                    </app-extension-filtering>
                </div>
            </ng-template>
        </n-tab-item>
    </n-tab>

    <n-footer>
        <button nButton [label]="i18n.btn.closeBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>

<ng-template #addClients>
    <div class="nfs-detail-tab">
        <p class="nfs-detail-tab-des mb-10" style="margin-top: -0.1rem;">{{i18n.tip.clientsTip}}</p>
        <app-client-nfs-share #clientDt [nfsShare]="data" [entry]="entry" [fileSystem]="fileSystem"></app-client-nfs-share>
    </div>
</ng-template>
